"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOrderNeedUserAction = exports.isOrderPayedStatus = exports.isOrderCanceledStatus = exports.getOrderStatus = exports.getOrderStatusType = exports.getOrderStatusMessage = exports.getOrderStatusLabel = exports.getOrderDeliveryStatus = exports.getOrderDeliveryStatusType = exports.getOrderDeliveryStatusLabel = exports.getOrderPaymentStatus = exports.getOrderPaymentStatusType = exports.getOrderPaymentStatusLabel = void 0;
var Order_1 = require("../../Enums/Order");
var DateFormat_1 = require("../Dates/DateFormat");
var Messages_1 = require("../../Enums/Messages");
var getOrderPaymentStatusLabel = function (order) {
    switch (order === null || order === void 0 ? void 0 : order.frontStatus) {
        case Order_1.OrderFrontStatus.canceled_can_resume:
        case Order_1.OrderFrontStatus.canceled_can_not_resume:
        case Order_1.OrderFrontStatus.refunded:
            return "Annulée";
        case Order_1.OrderFrontStatus.paiement_failed_can_not_resume:
        case Order_1.OrderFrontStatus.paiement_failed_can_resume:
        case Order_1.OrderFrontStatus.paiement_3ds:
            return "Erreur paiement";
        case Order_1.OrderFrontStatus.delivered:
        case Order_1.OrderFrontStatus.payed:
        case Order_1.OrderFrontStatus.preparation:
            return "Payée";
        default:
            return "En attente";
    }
};
exports.getOrderPaymentStatusLabel = getOrderPaymentStatusLabel;
var getOrderPaymentStatusType = function (order) {
    switch (order === null || order === void 0 ? void 0 : order.frontStatus) {
        case Order_1.OrderFrontStatus.canceled_can_resume:
        case Order_1.OrderFrontStatus.canceled_can_not_resume:
        case Order_1.OrderFrontStatus.refunded:
            return Messages_1.MessageType.Error;
        case Order_1.OrderFrontStatus.paiement_failed_can_not_resume:
        case Order_1.OrderFrontStatus.paiement_failed_can_resume:
        case Order_1.OrderFrontStatus.paiement_3ds:
            return Messages_1.MessageType.Warning;
        case Order_1.OrderFrontStatus.delivered:
        case Order_1.OrderFrontStatus.payed:
        case Order_1.OrderFrontStatus.preparation:
        default:
            return Messages_1.MessageType.Success;
    }
};
exports.getOrderPaymentStatusType = getOrderPaymentStatusType;
var getOrderPaymentStatus = function (order) {
    return {
        label: (0, exports.getOrderPaymentStatusLabel)(order), type: (0, exports.getOrderPaymentStatusType)(order)
    };
};
exports.getOrderPaymentStatus = getOrderPaymentStatus;
var getOrderDeliveryStatusLabel = function (order) {
    switch (order === null || order === void 0 ? void 0 : order.frontStatus) {
        case Order_1.OrderFrontStatus.canceled_can_resume:
        case Order_1.OrderFrontStatus.canceled_can_not_resume:
        case Order_1.OrderFrontStatus.refunded:
        case Order_1.OrderFrontStatus.paiement_failed_can_not_resume:
            return "Annulée";
        case Order_1.OrderFrontStatus.delivered:
            return "Livrée";
        case Order_1.OrderFrontStatus.payed:
        case Order_1.OrderFrontStatus.preparation:
        case Order_1.OrderFrontStatus.validated:
        case Order_1.OrderFrontStatus.paiement_3ds:
        case Order_1.OrderFrontStatus.paiement_failed_can_resume:
        default:
            return "À venir";
    }
};
exports.getOrderDeliveryStatusLabel = getOrderDeliveryStatusLabel;
var getOrderDeliveryStatusType = function (order) {
    switch (order === null || order === void 0 ? void 0 : order.frontStatus) {
        case Order_1.OrderFrontStatus.canceled_can_resume:
        case Order_1.OrderFrontStatus.canceled_can_not_resume:
        case Order_1.OrderFrontStatus.refunded:
        case Order_1.OrderFrontStatus.paiement_failed_can_not_resume:
            return Messages_1.MessageType.Error;
        case Order_1.OrderFrontStatus.delivered:
            return Messages_1.MessageType.Success;
        case Order_1.OrderFrontStatus.payed:
        case Order_1.OrderFrontStatus.preparation:
        case Order_1.OrderFrontStatus.validated:
        case Order_1.OrderFrontStatus.paiement_3ds:
        case Order_1.OrderFrontStatus.paiement_failed_can_resume:
        default:
            return Messages_1.MessageType.Neutral;
    }
};
exports.getOrderDeliveryStatusType = getOrderDeliveryStatusType;
var getOrderDeliveryStatus = function (order) {
    return {
        label: (0, exports.getOrderDeliveryStatusLabel)(order), type: (0, exports.getOrderDeliveryStatusType)(order)
    };
};
exports.getOrderDeliveryStatus = getOrderDeliveryStatus;
var getOrderStatusLabel = function (order) {
    switch (order === null || order === void 0 ? void 0 : order.frontStatus) {
        case Order_1.OrderFrontStatus.canceled_can_resume:
        case Order_1.OrderFrontStatus.canceled_can_not_resume:
        case Order_1.OrderFrontStatus.refunded:
            return "Annulée";
        case Order_1.OrderFrontStatus.paiement_failed_can_not_resume:
        case Order_1.OrderFrontStatus.paiement_failed_can_resume:
        case Order_1.OrderFrontStatus.paiement_3ds:
            return "Erreur paiement";
        case Order_1.OrderFrontStatus.delivered:
            return "Livrée";
        case Order_1.OrderFrontStatus.payed:
        case Order_1.OrderFrontStatus.preparation:
            return "Payée";
        case Order_1.OrderFrontStatus.validated:
            return "En cours";
        default:
            return "En attente";
    }
};
exports.getOrderStatusLabel = getOrderStatusLabel;
var getOrderStatusMessage = function (order) {
    switch (order === null || order === void 0 ? void 0 : order.frontStatus) {
        case Order_1.OrderFrontStatus.canceled_can_resume:
            return '<b>Annulée&nbsp;:&nbsp;</b>votre commande à été annulée. Vous pouvez la réactiver au plus tard 2 jours avant la livraison.';
        case Order_1.OrderFrontStatus.paiement_failed_can_not_resume:
        case Order_1.OrderFrontStatus.canceled_can_not_resume:
            return '<b>Annulée&nbsp;:&nbsp;</b>votre commande à été annulée et il est trop tard pour la réactiver. Vous n’avez pas été prélevé.';
        case Order_1.OrderFrontStatus.refunded:
            return "<b>Annulée&nbsp;:&nbsp;</b>votre commande à été annulée et remboursée sous forme de coupon à retrouver dans votre compte. ";
        case Order_1.OrderFrontStatus.validated:
            return "<b>En cours&nbsp;:&nbsp;</b>compl\u00E9tez ou modifiez votre commande jusqu\u2019au ".concat((0, DateFormat_1.tmsToFormat)(order === null || order === void 0 ? void 0 : order.limitDate, "eee d MMM 'à' HH'h'mm"), ".");
        case Order_1.OrderFrontStatus.paiement_3ds:
        case Order_1.OrderFrontStatus.paiement_failed_can_resume:
            return '<b>Erreur paiement&nbsp;:&nbsp;</b>une erreur est survenue lors du paiement de votre commande. Veuillez réessayer.';
        case Order_1.OrderFrontStatus.payed:
        case Order_1.OrderFrontStatus.preparation:
            return '<b>Payée&nbsp;:&nbsp;</b>votre commande à été payée, elle sera bientôt préparée et livrée par nos équipes.';
        case Order_1.OrderFrontStatus.delivered:
            return '<b>Livrée&nbsp;:&nbsp;</b>votre commande à été livrée dans votre point relais et n’attend plus que vous !';
        default:
            return undefined;
    }
};
exports.getOrderStatusMessage = getOrderStatusMessage;
var getOrderStatusType = function (order) {
    switch (order === null || order === void 0 ? void 0 : order.frontStatus) {
        case Order_1.OrderFrontStatus.canceled_can_resume:
        case Order_1.OrderFrontStatus.canceled_can_not_resume:
        case Order_1.OrderFrontStatus.refunded:
        case Order_1.OrderFrontStatus.paiement_failed_can_not_resume:
            return Messages_1.MessageType.Error;
        case Order_1.OrderFrontStatus.paiement_failed_can_resume:
        case Order_1.OrderFrontStatus.paiement_3ds:
            return Messages_1.MessageType.Warning;
        case Order_1.OrderFrontStatus.delivered:
            return Messages_1.MessageType.Success;
        case Order_1.OrderFrontStatus.payed:
        case Order_1.OrderFrontStatus.preparation:
        case Order_1.OrderFrontStatus.validated:
        default:
            return Messages_1.MessageType.Neutral;
    }
};
exports.getOrderStatusType = getOrderStatusType;
var getOrderStatus = function (order) {
    var label = (0, exports.getOrderStatusLabel)(order);
    var message = (0, exports.getOrderStatusMessage)(order);
    var type = (0, exports.getOrderStatusType)(order);
    return { label: label, message: message, type: type };
};
exports.getOrderStatus = getOrderStatus;
var isOrderCanceledStatus = function (order) { return [Order_1.OrderFrontStatus.canceled_can_not_resume, Order_1.OrderFrontStatus.canceled_can_resume, Order_1.OrderFrontStatus.paiement_failed_can_not_resume, Order_1.OrderFrontStatus.refunded]
    .includes(order === null || order === void 0 ? void 0 : order.frontStatus); };
exports.isOrderCanceledStatus = isOrderCanceledStatus;
var isOrderPayedStatus = function (order) { return [Order_1.OrderFrontStatus.payed, Order_1.OrderFrontStatus.preparation, Order_1.OrderFrontStatus.delivered]
    .includes(order === null || order === void 0 ? void 0 : order.frontStatus); };
exports.isOrderPayedStatus = isOrderPayedStatus;
var isOrderNeedUserAction = function (order) {
    var _a;
    var isPayableAndNotBatch = !!((_a = order === null || order === void 0 ? void 0 : order.stripePayment) === null || _a === void 0 ? void 0 : _a.isPayable) && !(order === null || order === void 0 ? void 0 : order.canWaitForBatch);
    var isFrontStatusRetry = [Order_1.OrderFrontStatus.paiement_failed_can_resume, Order_1.OrderFrontStatus.paiement_3ds].includes(order === null || order === void 0 ? void 0 : order.frontStatus);
    return isPayableAndNotBatch || isFrontStatusRetry;
};
exports.isOrderNeedUserAction = isOrderNeedUserAction;
exports.default = {
    getOrderPaymentStatus: exports.getOrderPaymentStatus,
    getOrderDeliveryStatus: exports.getOrderDeliveryStatus,
    getOrderStatus: exports.getOrderStatus,
    isOrderCanceledStatus: exports.isOrderCanceledStatus,
    isOrderPayedStatus: exports.isOrderPayedStatus,
    isOrderNeedUserAction: exports.isOrderNeedUserAction
};
//# sourceMappingURL=OrderStatus.js.map